import React from "react";

import "./About.css";
import aboutImg from "../../../img/szatnia/Rysunek1.jpg";

const about = () => {
  return (
    <section id="about-us" className="py-3">
      <div className="container p-5">
        <div className="row">
          <div className="col-md-8">
            <h1 className="mb-4">Szatnia samoobsługowa </h1>
            <h3 className="pb-3 orange-color">
              …uporządkuj sprawy…
            </h3>
            <p className="text-muted">
              Firma Akcent-bud istnieje na rynku od 1997 roku. Podstawową
              działalnością jest projektowanie architektoniczne i wykonawstwo
              budowlane. To właśnie w czasie projektowania pewnego wnętrza
              pojawił się problem szatni. Nie było dla niej miejsca w
              istniejącym układzie pomieszczeń budynku, a inwestor chciał też
              uniknąć dodatkowego etatu i zatrudnienia. Rozwiązaniem okazała się
              nasza e-szatnia samoobsługową.
            </p>
          </div>
          <div className="col-md-4 d-flex align-items-center">
            <img src={aboutImg} alt="" className="img-fluid" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default about;



// WEBPACK FOOTER //
// ./src/components/Cloackroom/About/About.js